import { HotelAdapter } from '../adapters/booking-api-client/hotel.ts'

import { defineBackendStore } from './backend-store.ts'

import type { HotelAdapterProps } from '../adapters/booking-api-client/hotel.ts'
import type { HotelsLangEnum } from '@revolugo/booking-api-client'

export interface HotelModule {
  retrieve: ({
    id,
    lang,
  }: {
    id: string
    lang: HotelsLangEnum
  }) => Promise<HotelAdapterProps>
}

export const useHotelServiceStore = defineBackendStore<HotelModule>(
  'hotels-service',
  {
    actions: {
      async retrieve({ id, lang }): Promise<HotelAdapterProps> {
        const hotelPayload = await this.apiClient.hotelsService.retrieve({
          id,
          lang,
        })
        const hotelAdapter = new HotelAdapter(hotelPayload)
        return hotelAdapter.toHotel()
      },
    },
  },
)
